import { useState } from "react";

interface FilterBarProps {
  genreOptions: string[];
  filters: {
    region: string;
    year: string;
    genre: string;
    sort: string;
  };
  onChange: (key: "region" | "year" | "genre" | "sort", value: string) => void;
  regions: string[];
  years: string[];
  sortOptions: string[];
  total: number;
}

const rows: { key: "genre" | "region" | "year" | "sort"; label: string }[] = [
  { key: "genre", label: "类型" },
  { key: "region", label: "地区" },
  { key: "year", label: "年份" },
  { key: "sort", label: "排序" },
];

export default function FilterBar({
  genreOptions,
  filters,
  onChange,
  regions,
  years,
  sortOptions,
  total,
}: FilterBarProps) {
  const [mobileOpen, setMobileOpen] = useState(false);

  const optionsMap = {
    genre: genreOptions,
    region: regions,
    year: years,
    sort: sortOptions,
  };

  const activeCount = [filters.region, filters.year, filters.genre, filters.sort].filter(
    (value) => value !== "全部" && value !== "最新上线"
  ).length;

  return (
    <div className="rounded-lg border border-background-200/80 bg-background-50">
      <div className="flex items-center justify-between gap-3 px-4 py-3 md:hidden">
        <button
          type="button"
          onClick={() => setMobileOpen((open) => !open)}
          className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md border border-background-300 text-sm text-foreground-800 cursor-pointer"
        >
          <i className="ri-filter-3-line"></i>
          筛选条件
          {activeCount > 0 && (
            <span className="w-5 h-5 flex items-center justify-center rounded-full bg-accent-500 text-primary-950 text-[11px] font-label">
              {activeCount}
            </span>
          )}
          <i className={mobileOpen ? "ri-arrow-up-s-line" : "ri-arrow-down-s-line"}></i>
        </button>
        <span className="text-xs text-foreground-500">共 {total} 部</span>
      </div>

      <div className={`${mobileOpen ? "block" : "hidden"} md:block px-4 pb-4 md:py-4`}>
        {rows.map((row) => (
          <div
            key={row.key}
            className="flex flex-col md:flex-row md:items-start gap-2 md:gap-4 py-2.5 border-b border-background-100 last:border-b-0 md:last:border-b-0"
          >
            <span className="text-xs text-foreground-500 md:w-12 shrink-0 md:pt-1.5">{row.label}</span>
            <div className="flex flex-wrap gap-1.5 md:gap-2 flex-1">
              {(optionsMap[row.key] as string[]).map((option) => {
                const active = filters[row.key] === option;
                return (
                  <button
                    key={option}
                    type="button"
                    onClick={() => onChange(row.key, option)}
                    className={`px-3 py-1.5 rounded-md text-xs whitespace-nowrap transition-colors cursor-pointer ${
                      active
                        ? "bg-primary-500 text-background-50"
                        : "text-foreground-600 hover:bg-background-100 hover:text-primary-600"
                    }`}
                  >
                    {option}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
        <div className="hidden md:flex items-center justify-between pt-3 mt-1 border-t border-background-100">
          <span className="text-xs text-foreground-500">筛选结果共 {total} 部作品</span>
          <span className="text-[11px] text-foreground-400">点击条件即可实时刷新列表</span>
        </div>
      </div>
    </div>
  );
}